<template>
  <div class="modal-overlay" @click="fnCloseModal">
    <div class="modal-bottom" @click.stop>
      <div class="modal-content">
        <h3 class="modal-title">알림을 켜주세요</h3>
        <p class="modal-description">
          리포트 발급 진행현황, 등기변동 시 알림 등<br />서비스 이용에 필요한
          알림을 보내드려요!
        </p>

        <div class="noti_example_container">
          <div class="noti_example">
            <div class="noti_example_icon">
              <img src="@/assets/images/settings/nzsc.svg" />
            </div>
            <div class="noti_example_desc">
              <div class="noti_example_desc_title">리포트 발급 완료</div>
              <div class="noti_example_desc_content">
                우리집 담당자가 리포트를 발급 완료했어요
              </div>
            </div>
          </div>
          <div class="noti_example">
            <div class="noti_example_icon">
              <img src="@/assets/images/settings/nzsc.svg" />
            </div>
            <div class="noti_example_desc">
              <div class="noti_example_desc_title">
                세금 체납으로 인한 압류 발생
              </div>
              <div class="noti_example_desc_content">
                집이 공매로 넘어갈 수 있어요
              </div>
            </div>
          </div>
        </div>

        <div class="btn_group">
          <div class="btn_no" @click="fnNotificationNo">안 받을래요</div>
          <div class="btn_yes" @click="fnNotificationYes">알림 받을래요</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/common.css";
import { mapState } from "vuex";

export default {
  name: "NotificationPopupComponent",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(["_state"]),
  },
  mounted() {},
  methods: {
    fnCloseModal() {
      const modalBottom = this.$el.querySelector(".modal-bottom");
      modalBottom.classList.remove("slide-up");
      modalBottom.classList.add("slide-down");

      // 애니메이션 완료 후 close 이벤트 발생
      setTimeout(() => {
        this.$emit("close");
      }, 300); // 300ms = 애니메이션 시간
    },
    fnPostMessageNotificationYes() {
      // window.console.log(
      //   "fnPostMessageNotificationYes - flutterWebViewReady: ",
      //   this._state.flutterWebViewReady
      // );
      if (this._state.flutterWebViewReady) {
        window.flutter_inappwebview
          .callHandler("requestNotification")
          .then(function (result) {
            window.console.log(
              "requestNotification result: ",
              JSON.stringify(result)
            );
          });
      }
    },
    fnNotificationYes() {
      this.$mixpanel_track("Click Operation-Alert On");
      this.fnPostMessageNotificationYes();
      this.$emit("close");
    },
    fnNotificationNo() {
      this.$mixpanel_track("Click Operation-Alert Off");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 40%;
  max-width: 450px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  /* 채널톡 버튼의 z-index (10000000) 보다 높아야 함. */
  z-index: 20000000;
  right: calc(25vw - 340px);
}

.modal-bottom {
  width: 100%;
  max-width: 450px;
  background: white;
  border-radius: 20px 20px 0 0;
}

.modal-content {
  padding: 24px 20px;
}

.modal-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #121212;
  text-align: left;
  margin-bottom: 12px;
}

.modal-description {
  font-size: 14px;
  font-weight: 400;
  color: #121212;
  line-height: 20px;
  text-align: left;
  margin-bottom: 24px;
}

.noti_example_container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 30px;
}
.noti_example {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 9px;
  padding: 16px 14px;
  background: #f4f6f9;
  border-radius: 10px;
}
.noti_example_icon img {
  width: 38px;
  height: 38px;
}
.noti_example_desc {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.noti_example_desc_title {
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  color: #121212;
}
.noti_example_desc_content {
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: var(--Grayscale-Darkgray, #606060);
}

.btn_group {
  display: flex;
  flex-direction: row;
  gap: 11px;
}
.btn_yes {
  display: flex;
  width: 100%;
  height: 44px;
  border-radius: 10px;
  background: var(--Safe-main, #5087ff);
  color: var(--Grayscale-White, #fff);
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
}
.btn_no {
  display: flex;
  width: 100%;
  height: 44px;
  border-radius: 10px;
  background: var(--Grayscale-White, #fff);
  border: 1.2px solid var(--Safe-main, #5087ff);
  color: var(--Safe-main, #5087ff);
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
}

/* 모달 애니메이션 */
.slide-up {
  animation: slideUp 0.3s ease-out;
}

.slide-down {
  animation: slideDown 0.3s ease-in;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}

/* 모바일 대응 */
@media screen and (max-width: 1080px) {
  .modal-overlay {
    width: 100%;
    max-width: 100%;
    right: 0;
  }

  .modal-bottom {
    max-width: 100%;
  }
}
</style>
